import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialsTableComponent } from '../inventory-dialog/materials-table/materials-table.component';
import { EditMaterialDialogComponent } from '../inventory-dialog/edit-material-dialog/edit-material-dialog.component';
import { BulkDeleteMaterialsDialogComponent } from '../inventory-dialog/bulk-delete-materials-dialog/bulk-delete-materials-dialog.component';
import { MaterialsService } from '../../../services/materials.service';
import { BulkDeleteMaterialsDto } from '@models/bulk-delete-materials-dto.interface';

@Component({
  selector: 'app-inventory-page',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MaterialsTableComponent],
  templateUrl: './inventory-page.component.html',
  styleUrl: './inventory-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryPageComponent {
  private readonly dialog = inject(MatDialog);
  private readonly materialsService = inject(MaterialsService);

  @ViewChild(MaterialsTableComponent) private materialsTable!: MaterialsTableComponent;

  protected onCreateClick(): void {
    this.dialog
      .open(EditMaterialDialogComponent, {
        width: '750px',
        minWidth: '750px',
        maxHeight: '90vh',
        data: {},
      })
      .afterClosed()
      .subscribe((newId: number | undefined) => {
        if (newId) {
          this.materialsTable?.reload();
        }
      });
  }

  protected onBulkDeleteClick(): void {
    this.dialog
      .open(BulkDeleteMaterialsDialogComponent, {
        width: '680px',
        maxWidth: '900px',
      })
      .afterClosed()
      .subscribe((dto: BulkDeleteMaterialsDto | undefined) => {
        if (dto) {
          this.materialsService.bulkDeleteMaterials(dto).subscribe({
            next: () => this.materialsTable?.reload(),
          });
        }
      });
  }
}
